import { CommonStatus, StatusWorking, UserPlan } from "../../constants/enum";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { getListHost, getListHostCount } from "../../api/host";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Cookies from "js-cookie";
import { Pagination } from "antd";
import StaffComponent from "../Staff";
import { StaffContext } from "../../providers/StaffProvider";
import { StaffType } from "../../types/StaffType";
import { TakuTypeStaff } from "../../types/TakuTypeStaff";
import classNames from "classnames";
import { colors } from "../../constants/constans";
import { getDefaultConfigOfTable } from "../../api/table";
import { handleErrorMessage } from "../../utils/helper/common";
import { queryKeys } from "../../constants/constans";
import styles from "./styles.module.scss";
import { updateTableSession } from "../../api/tableSession";
import useDragStaff from "../../hooks/useDragStaff";
import useInRandom from "../../hooks/useInRandom";
import useNetworkStatus from "hooks/useNetworkStatus";
import useSetOkuriList from "../../hooks/useSetOkuriList";
import useSetOrderList from "../../hooks/useSetOrderList";
import useSetTimeLineInfo from "../../hooks/useTimeLineInfo";
import useShowListStaff from "hooks/useShowListStaff";

export const TakuSetteiStaff = (props: TakuTypeStaff) => {
  const {
    takuId, //スタッフ周りのデータ足してく
    setDragIndex,
    isDrop,
    listStaffNotPriority,
    setListStaffNotPriority,
    setIsTLDrag,
    inViewAllTable,
    cls,
    tableEdit,
    listStaffCandidacy,
    setListStaffCandidacy,
  } = props;

  const { staff, setStaffDrag } = useDragStaff();
  const { timeLineInfo, setTimeLineInfo } = useSetTimeLineInfo();
  const { orderList, setOrderList } = useSetOrderList();
  const { okuriList, setOkuriList } = useSetOkuriList();
  const [ranking, setRanking] = useState<number>(1);
  const queryClient = useQueryClient();
  const isOnline = useNetworkStatus();
  const { setInRandom } = useInRandom();
  const { setShowListStaff, showListStaff } = useShowListStaff();
  const userPlan = Cookies.get("userPlan");
  const updateTableSessionAction = useMutation(updateTableSession);

  const { data: staffList } = useQuery(queryKeys.listHost, {}) as any;
  const { data: staffCount } = useQuery(queryKeys.staffCount, () =>
    getListHostCount({})
  );
  const { data: defaultConfig } = useQuery(
    queryKeys.defaultConfigTable,
    getDefaultConfigOfTable
  );

  const dragStart = (staff: StaffType, index: number) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }

    //スタッフIDをドラッグしている情報
    setStaffDrag(staff);
    if (setDragIndex != undefined) {
      setDragIndex(index);
    }
    //タイムラインからドラッグされてない状態にする
    if (setIsTLDrag != undefined) {
      setIsTLDrag(false);
    }
  };

  const dragEnd = (index: number) => {};

  const onDrop = () => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }

    if (staff && staff.isFromTimeLine) {
      const newTimeLineInfo = timeLineInfo.filter(
        (item: StaffType) =>
          !(item?.block === staff.block && item?.index === staff?.index)
      );
      setInRandom(false);
      setTimeLineInfo(newTimeLineInfo);
    }

    if (
      staff &&
      staff.isFromTimeLineInList &&
      staff?.isFromTimeLineInListActive
    ) {
      const newTimeLineInfo = staff?.infoTable?.timeLineInfo.filter(
        (item: StaffType) =>
          !(item?.block === staff.block && item?.index === staff?.index)
      );
      updateTableSessionAction.mutate(
        {
          id: (staff?.infoTable as any)?._id,
          data: {
            ...staff?.infoTable,
            timeLineInfo: newTimeLineInfo,
          },
        },
        {
          onSuccess: (data) => {
            queryClient.invalidateQueries(queryKeys.listTableSession);
            queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
            queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
            queryClient.invalidateQueries(queryKeys.staffCount);
          },
          onError: (err) => {
            if (!!isOnline) {
              handleErrorMessage(err);
              return;
            }
            const listTableSessionCurrent = queryClient.getQueryData(
              queryKeys.listTableSession
            ) as any;
            if (Array.isArray(listTableSessionCurrent?.data)) {
              const tableTmp = {
                ...staff?.infoTable,
                timeLineInfo,
              };

              const listTableSessionNew = listTableSessionCurrent?.data?.map(
                (item: any) => {
                  if (
                    String(item?._id) === String((staff?.infoTable as any)?._id)
                  ) {
                    return {
                      ...item,

                      timeLineInfo,
                    };
                  }
                  return item;
                }
              );
              queryClient.setQueryData(queryKeys.listTableSession, {
                data: listTableSessionNew,
              });
            }
          },
        }
      );
    }
    if (staff && staff.isFromOrder) {
      const orderListNew = orderList?.filter(
        (item: any) =>
          !(item?.index === staff?.index && item?.staff?.id === staff.id)
      );
      setOrderList(orderListNew);
    }
    if (staff && !staff.isFromOrder) {
      const okuriListNew = okuriList?.filter(
        (item: any) =>
          !(item?.index === staff?.index && item?.staff?.id === staff.id)
      );
      setOkuriList(okuriListNew);
    }
  };

  const handleGetBackground = (id: string) => {
    // if (defaultConfig?.data?.autoNextStep === CommonStatus.ACTIVE) {
    //   return "";
    // }
    // if (
    //   defaultConfig?.data?.autoCandidacy === CommonStatus.ACTIVE &&
    //   !timeLineInfo?.find((item: any) => item?.id === id)
    // ) {
    //   return "";
    // }
    const staffInList = orderList?.filter(
      (item: any) => String(item?.staff?.id) === String(id)
    );

    const listIndex = staffInList?.map((item: any) => Number(item?.index));

    const colorsOfStaff = colors.filter((_, index) =>
      listIndex?.includes(Number(index))
    );
    if (colorsOfStaff?.length < 1) {
      return "";
    }
    if (colorsOfStaff?.length < 2) {
      return colorsOfStaff?.[0];
    }

    const colorPercent = 100 / colorsOfStaff?.length;

    let result = `linear-gradient(to right,`;

    colorsOfStaff?.forEach((color, index) => {
      result += color + " " + colorPercent * index + "%,";
      result += color + " " + colorPercent * (index + 1) + "%";

      if (index !== colorsOfStaff.length - 1) {
        result += ",";
      }
    });
    return result;
  };

  const getStaffCount = (staffId: string) => {
    if (typeof staffCount?.data === "object") {
      return Object.keys(staffCount?.data)?.includes(staffId)
        ? Number(staffCount?.data?.[`${staffId}`])
        : 0;
    }
    return 0;
  };

  const handleChangePage = (value: number) => {
    setRanking(value);
  };

  const handleDropOverlay = (e: any) => {
    if (inViewAllTable) {
      if (defaultConfig?.data?.autoCandidacy === CommonStatus.ACTIVE) {
        let listStaff = [...(listStaffCandidacy || [])];

        if (listStaffCandidacy?.includes(staff?.id)) {
          listStaff = listStaffCandidacy?.filter((item) => item !== staff?.id);
        } else {
          listStaff.push(staff?.id);
        }
        updateTableSessionAction.mutate(
          {
            id: tableEdit,
            data: {
              listStaffCandidacy: listStaff,
            },
          },
          { onSuccess: () => {} }
        );
      } else {
        let listStaff = [...(listStaffNotPriority || [])];

        if (listStaffNotPriority?.includes(staff?.id)) {
          listStaff = listStaffNotPriority?.filter(
            (item) => item !== staff?.id
          );
        } else {
          listStaff.push(staff?.id);
        }
        updateTableSessionAction.mutate(
          {
            id: tableEdit,
            data: {
              listStaffNotPriority: listStaff,
            },
          },
          { onSuccess: () => {} }
        );
      }

      return;
    }
    if (
      staff.isFromOrder ||
      staff.isFromTimeLine ||
      !listStaffNotPriority ||
      !setListStaffNotPriority ||
      !listStaffCandidacy ||
      !setListStaffCandidacy
    ) {
      return;
    }

    if (defaultConfig?.data?.autoCandidacy === CommonStatus.ACTIVE) {
      let listStaff = [...listStaffCandidacy];

      if (listStaffCandidacy?.includes(staff?.id)) {
        listStaff = listStaffCandidacy?.filter((item) => item !== staff?.id);
      } else {
        listStaff.push(staff?.id);
      }
      setListStaffCandidacy(listStaff);
    } else {
      let listStaff = [...listStaffNotPriority];

      if (listStaffNotPriority?.includes(staff?.id)) {
        listStaff = listStaffNotPriority?.filter((item) => item !== staff?.id);
      } else {
        listStaff.push(staff?.id);
      }
      setListStaffNotPriority(listStaff);
    }
  };

  const handleShowListStaff = () => {
    setShowListStaff();
  };

  return (
    <>
      <div
        className={classNames("staffListSettei", styles.staffListSettei, {
          [cls]: !!cls,
          [styles.hideListStaff]: !showListStaff && !!inViewAllTable,
          [styles.inViewAllTable]: inViewAllTable,
        })}
        onDragOver={(e) => {
          e.preventDefault(); // これがないとdropイベントが発火しない
        }}
        onDrop={onDrop}
      >
        <h2>
          {!!inViewAllTable && (
            <div
              className={styles.btnShowListStaff}
              onClick={handleShowListStaff}
            >
              {showListStaff ? <RightOutlined /> : <LeftOutlined />}
            </div>
          )}

          {!!showListStaff && <span>スタッフリスト ({takuId}卓)</span>}
        </h2>
        {((!!showListStaff && !!inViewAllTable) || !inViewAllTable) && (
          <div className={classNames(styles.listContainer, "listContainer")}>
            {Array.isArray(staffList?.data) &&
              staffList?.data
                ?.filter((item: any) =>
                  [StatusWorking.Working, StatusWorking.WorkingLate].includes(
                    item?.infoWorking?.statusWorking
                  )
                )
                ?.filter((item: any) => item?.ranking === ranking)
                .sort(
                  (a: any, b: any) =>
                    Number(a.orderWorking) - Number(b.orderWorking)
                )
                ?.map((staff: any, index: number) => {
                  return (
                    <StaffComponent
                      disableShowStar={true}
                      key={index}
                      id={staff?.id}
                      staffName={staff?.staffName}
                      onDragStart={() => dragStart(staff, index)}
                      dragEnd={() => dragEnd(index)}
                      cls={classNames({
                        [styles.workingLate]:
                          staff?.infoWorking?.statusWorking ===
                          StatusWorking.WorkingLate,
                        ["staffCandidacy"]:
                          !listStaffCandidacy?.includes(staff?.id) &&
                          defaultConfig?.data?.autoCandidacy ===
                            CommonStatus.ACTIVE,
                      })}
                      backgroundWhite={
                        timeLineInfo?.find(
                          (item: any) => item?.id === staff?.id
                        ) ||
                        (defaultConfig?.data?.autoCandidacy ===
                          CommonStatus.ACTIVE &&
                          orderList?.find(
                            (item: any) => item?.staff?.id === staff?.id
                          ))
                      }
                      backgroundWhiteCandidacy={
                        defaultConfig?.data?.autoCandidacy ===
                          CommonStatus.ACTIVE &&
                        orderList?.find(
                          (item: any) => item?.staff?.id === staff?.id
                        ) &&
                        !timeLineInfo?.find(
                          (item: any) => item?.id === staff?.id
                        )
                      }
                      style={{
                        background: `${handleGetBackground(staff?.id)} `,
                      }}
                      star={staff?.star}
                      priority={!!listStaffNotPriority?.includes(staff?.id)}
                      showPriority={true}
                      count={getStaffCount(staff?.id)}
                    />
                  );
                })}
          </div>
        )}
        {((!!showListStaff && !!inViewAllTable) || !inViewAllTable) && (
          <div
            className={styles.paginationContainer}
            onDrop={handleDropOverlay}
            onDragOver={(e) => {
              e.preventDefault(); // これがないとdropイベントが発火しない
            }}
          >
            <Pagination
              defaultCurrent={1}
              total={Number(defaultConfig?.data?.pageRanking) * 10}
              onChange={handleChangePage}
            />
          </div>
        )}
      </div>
    </>
  );
};
